import {fullURL} from '../utils';
import axios from 'axios';

const SEGMENT_SAVE = 'SEGMENT_SAVE';
export const SEGMENT_UPDATE = 'SEGMENT_UPDATE';

const SEGMENT_DELETE = 'SEGMENT_DELETE';
const SEGMENT_REMOVE = 'SEGMENT_REMOVE';

const SEGMENT_FETCH_ALL = 'SEGMENT_FETCH_ALL';
const SEGMENT_SET_ALL = 'SEGMENT_SET_ALL';

const _set = segments => ({type: SEGMENT_SET_ALL, segments});
const _update = segment => ({type: SEGMENT_UPDATE, segment});
const _remove = segmentID => ({type: SEGMENT_REMOVE, segmentID});

export const initSegments = () => ({type: SEGMENT_FETCH_ALL});
export const saveSegment = segment => ({type: SEGMENT_SAVE, segment});
export const deleteSegment = segmentID => ({type: SEGMENT_DELETE, segmentID});

export default {
  state: {
    segmentList: []
  },

  getters: {
    getSegment: ({segmentList}) => segmentID => {
      return segmentList.find(({id}) => segmentID === id);
    }
  },

  mutations: {
    [SEGMENT_SET_ALL](state, {segments}) {
      state.segmentList = segments.sort((a, b) => {
        if (a.locked && !b.locked) return -1;
        return 0;
      });
    },

    [SEGMENT_UPDATE](state, {segment}) {
      const index = state.segmentList.findIndex(({id}) => id === segment.id);
      if (index < 0) state.segmentList.push(segment);
      else state.segmentList.splice(index, 1, {...state.segmentList[index], ...segment});
    },

    [SEGMENT_REMOVE](state, {segmentID}) {
      state.segmentList = state.segmentList.filter(({id}) => id !== segmentID);
    },
  },


  actions: {
    async [SEGMENT_FETCH_ALL]({commit}) {
      const {data} = await axios.get(fullURL('/segment/all'));
      commit(_set(data));
    },

    async [SEGMENT_DELETE]({commit, dispatch}, {segmentID}) {
      await axios.delete(fullURL(`/segment/${segmentID}`));
      commit(_remove(segmentID));
    },

    async [SEGMENT_SAVE]({commit}, {segment}) {
      const {data} = await axios.post(fullURL('/segment'), segment);
      commit(_update(data));
    }
  }
}
